// src/components/Logs/InstituicaoLogFilter.js

import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Search as SearchIcon, Refresh as RefreshIcon } from '@mui/icons-material';

// Adicionar constantes no início do arquivo
const ACOES_POSSIVEIS = [
  { value: '', label: 'Todas' },
  { value: 'CRIAR', label: 'Criar' },
  { value: 'ATUALIZAR', label: 'Atualizar' },
  { value: 'EXCLUIR', label: 'Excluir' },
  { value: 'CONSULTAR', label: 'Consultar' },
  { value: 'LOGIN', label: 'Login' },
  { value: 'LOGOUT', label: 'Logout' }
];

const ENTIDADES_DASHBOARD = [
  { value: '', label: 'Todas' },
  { value: 'ESTUDANTE', label: 'Estudantes' },
  { value: 'CAMPANHA', label: 'Campanhas' },
  { value: 'CURSO', label: 'Cursos' },
  { value: 'CLASSE', label: 'Classes' },
  { value: 'PLANOS-PAGAMENTO', label: 'Planos de Pagamento' },
  { value: 'PRE-INSCRICAO', label: 'Pré-Inscrições' },
  { value: 'SLIDERS', label: 'Sliders' },
  { value: 'DESTAQUES', label: 'Destaques' },
  { value: 'NOTIFICACOES', label: 'Notificações' },
  { value: 'DASHBOARD', label: 'Dashboard' },
  { value: 'RELATORIOS', label: 'Relatórios' },
  { value: 'DISCIPLINA', label: 'Disciplinas' },
  { value: 'PERIODO', label: 'Períodos' }
];

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: '200', label: 'Sucesso (200)' },
  { value: '201', label: 'Criado (201)' },
  { value: '304', label: 'Não Modificado (304)' },
  { value: '400', label: 'Erro Cliente (400)' },
  { value: '401', label: 'Não Autorizado (401)' },
  { value: '403', label: 'Proibido (403)' },
  { value: '404', label: 'Não Encontrado (404)' },
  { value: '500', label: 'Erro Servidor (500)' }
];

const InstituicaoLogFilter = ({ filters, onFilterChange, onRefresh }) => {
  // Handlers para mudança em cada campo de texto
  const handleTextChange = (field) => (event) => {
    onFilterChange(field, event.target.value);
  };

  // Handler para mudança nos DatePickers
  const handleDateChange = (field) => (date) => {
    onFilterChange(field, date);
  };

  // Handler para limpar os filtros
  const handleReset = () => {
    onFilterChange('reset', null);
  };

  return (
    <Grid container spacing={2} alignItems="center">
      {/* Ação */}
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label="Ação"
          value={filters.acao || ''}
          onChange={handleTextChange('acao')}
        >
          {ACOES_POSSIVEIS.map(opcao => (
            <MenuItem key={opcao.value} value={opcao.value}>
              {opcao.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Entidade */}
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label="Entidade"
          value={filters.entidade || ''}
          onChange={handleTextChange('entidade')}
        >
          {ENTIDADES_DASHBOARD.map(opcao => (
            <MenuItem key={opcao.value} value={opcao.value}>
              {opcao.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Status */}
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label="Status"
          value={filters.status || ''}
          onChange={handleTextChange('status')}
        >
          {STATUS_OPTIONS.map(opcao => (
            <MenuItem key={opcao.value} value={opcao.value}>
              {opcao.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Data Início */}
      <Grid item xs={12} sm={6} md={2}>
        <DatePicker
          label="Data Início"
          value={filters.dataInicio || null}
          onChange={handleDateChange('dataInicio')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      {/* Data Fim */}
      <Grid item xs={12} sm={6} md={2}>
        <DatePicker
          label="Data Fim"
          value={filters.dataFim || null}
          onChange={handleDateChange('dataFim')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      {/* Botões */}
      <Grid item xs={12} sm={6} md={2}>
        <Box display="flex" gap={1}>
          {/* Botão para limpar */}
          <Button
            variant="outlined"
            onClick={handleReset}
            fullWidth
          >
            <RefreshIcon fontSize="small" sx={{ mr: 1 }} />
            Limpar
          </Button>

          {/* Botão para buscar (refresh) */}
          <Button
            variant="contained"
            color="primary"
            onClick={onRefresh}
            fullWidth
          >
            <SearchIcon fontSize="small" sx={{ mr: 1 }} />
            Buscar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

InstituicaoLogFilter.propTypes = {
  filters: PropTypes.shape({
    acao: PropTypes.string,
    entidade: PropTypes.string,
    status: PropTypes.string,
    dataInicio: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.oneOf([null])
    ]),
    dataFim: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.oneOf([null])
    ])
  }),
  onFilterChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

InstituicaoLogFilter.defaultProps = {
  filters: {
    acao: '',
    entidade: '',
    status: '',
    dataInicio: null,
    dataFim: null
  }
};

export default InstituicaoLogFilter;
